export default function About() {
  return (
    <div style={{ padding: 60 }}>
      <h1 style={{ fontSize: 40 }}>About</h1>

      <p style={{ marginTop: 2, lineHeight: 1.6 }}>
        Architecture studio focused on innovative and sustainable design.
      </p>
    </div>
  );
}
